export function countdown() {
  const els = document.querySelectorAll('.js-countdown-el');
  if(els.length) {
    els.forEach((el,index) => {
      const startDateString = el.dataset.startDate;
      const endDateString = el.dataset.endDate;

      if (startDateString && endDateString) {
        // タイムゾーンを日本（JST, UTC+9）に設定
        const startDate = new Date(startDateString + 'T00:00:00+09:00');
        const endDate = new Date(endDateString + 'T00:00:00+09:00');

        // 言語判定（ja/en）
        const lang = document.documentElement.lang || 'ja';
        const isEnglish = lang.toLowerCase().includes('en');

        // テキスト定義
        const texts = {
          beforeStart: isEnglish ? ' Days until the festival' : '開幕まであと',
          startToday: isEnglish ? 'Starts Today!' : '今日から開幕します！',
          duringFestival: isEnglish ? ' Days remaining' : '閉幕まであと',
          duringDay: isEnglish ? 'Day ' : '開催',
          duringDayUnit: isEnglish ? '! ' : '日目！ ',
          afterEnd: isEnglish ? 'Thank you for coming!' : '閉幕しました！ありがとうございました！',
          dayUnit: isEnglish ? '' : '日'
        };

        // カウントダウン更新関数
        function updateCountdown() {
          // 現在の日時を取得（日本時間に変換）
          const now = new Date();
          const nowJST = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (9 * 3600000));

          // 今日の日付を取得（時間を00:00:00にリセット）
          const today = new Date(nowJST);
          today.setHours(0, 0, 0, 0);

          // 開始日と終了日も時間をリセット
          const startDateOnly = new Date(startDate);
          startDateOnly.setHours(0, 0, 0, 0);
          const endDateOnly = new Date(endDate);
          endDateOnly.setHours(0, 0, 0, 0);

          // 日付の比較と表示
          if (today < startDateOnly) {
            // 会期開始前
            const diffTime = startDateOnly - today;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (isEnglish) {
              el.innerText = `${diffDays}${texts.beforeStart}`;
            } else {
              el.innerText = `${texts.beforeStart}${diffDays}${texts.dayUnit}`;
            }
          } else if (today.getTime() === startDateOnly.getTime()) {
            // 会期開始日
            el.innerText = texts.startToday;
          } else if (today > startDateOnly && today <= endDateOnly) {
            // 会期中
            // 開催何日目かを計算
            const daysSinceStart = Math.floor((today - startDateOnly) / (1000 * 60 * 60 * 24)) + 1;
            // 終了までの残り日数を計算
            const diffTime = endDateOnly - today;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (isEnglish) {
              el.innerText = `${texts.duringDay}${daysSinceStart}${texts.duringDayUnit} ${diffDays}${texts.duringFestival}`;
            } else {
              el.innerText = `${texts.duringDay}${daysSinceStart}${texts.duringDayUnit}${texts.duringFestival}${diffDays}${texts.dayUnit}`;
            }
          } else {
            // 会期終了後
            el.innerText = texts.afterEnd;
          }
        }

        // 初回実行
        updateCountdown();

        // 1秒ごとに更新
        setInterval(updateCountdown, 1000);
      }
    })
  }
}